import styled from "styled-components";
import {
  CardVehicleAndDriver,
  TripOrPlanningCard,
  dateFormatterDayMonthYear2Digits,
  dateFormatterHourMinute,
} from "@qivia/ui";
import { Tooltip } from "react-leaflet";
import { VehicleGeolocated } from "./index";
import { TripsDetails } from "../fleet/trips/tripsApi";

export const TooltipTripCard = (props: {
  vehicle: VehicleGeolocated;
  trip: TripsDetails;
  dataPointDate: string;
}) => {
  const { vehicle, trip, dataPointDate } = props;
  return (
    <Tooltip
      direction="top"
      offset={[0, -20]}
      opacity={1}
      permanent={true}
      className="vehicle-tooltip"
    >
      <StyledCardWrapper>
        <TripOrPlanningCard
          type="TRIP"
          dataDisplay={{
            distance: trip.distance,
            duration: Math.round((trip.secondsDuration ?? 0) / 60),
            startDate: trip.startDate,
            endDate: trip.endDate,
            // ecoDrivingScore: trip.ecoDrivingScore,
            driver: vehicle.driverName,
            clientName: null,
            clientCity: null,
            hasKmClient: false,
            activityType: null,
            isOutIntervention: false,
          }}
          headerProps={
            <CardVehicleAndDriver
              vehicle={vehicle}
              badgeText={vehicle.reference}
              rightElement={
                <StyledHour>
                  <div>
                    {dateFormatterDayMonthYear2Digits(new Date(dataPointDate))}
                  </div>
                  {dateFormatterHourMinute(new Date(dataPointDate)).replaceAll(
                    ":",
                    "h",
                  )}
                </StyledHour>
              }
              distance={vehicle.distance || 0}
              onClick={() => undefined}
              $withShadow={false}
            />
          }
        />
      </StyledCardWrapper>
    </Tooltip>
  );
};

const StyledCardWrapper = styled.div`
  width: 24rem;
`;

const StyledHour = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
